<div class="reader-wrapper">
    <div class="reader-header">
        <span>Charger Summary</span>
    </div>
    <div class="form-wrapper">
        <div class="top-strip">
            <p class="station-name">{{ stationName }}</p>
            <!-- <div class="charging-status-box">
                <p class="charging-dot"></p>
                <p class="charging-status">connectorStatus</p>
            </div> -->
        </div>

        <div class="container">
            <div class="message-wrapper">
                <h2>🔋 Thank You for Charging with Us!</h2>
                <p>Your vehicle has been successfully charged.</p>
                <p>We appreciate your trust in our EV charging station.</p>
                <p>Drive safe and stay eco-friendly!</p>
            </div>
            <div class="details-box">
                <div class="detail-row">
                    <span>Start Time</span>
                    <strong>{{ consumptionData.start_time }}</strong>
                </div>
                <div class="detail-row">
                    <span>Stop Time</span>
                    <strong>{{ consumptionData.stop_time }}</strong>
                </div>
                <div class="detail-row">
                    <span>Energy Consumed</span>
                    <strong>{{ consumptionData.energy_consumed }} Kw/h</strong>
                </div>
                <div class="detail-row">
                    <span>Duration</span>
                    <strong>{{ consumptionData.duration_in_minutes }}</strong>
                </div>
                <div class="detail-row">
                    <span>Amount</span>
                    <strong>{{ consuptionBalance }}</strong>
                </div>
            </div>

            <a [routerLink]="['/charger-home']" class="back-to-home">
                Back to Home
            </a>
        </div>

    </div>
    <footer class="web-footer">
        <a href="https://ezy-charge.com/about-us.php" target="_blank" style="color: #00796a;">About Us</a>
        <a href="https://ezy-charge.com/contact.php" target="_blank" style="color: #00796a;">Contact Us</a>
        <a href="https://ezy-charge.com/privacy-policy.php" target="_blank" style="color: #00796a;">Privacy & Policy</a>
        <a href="https://ezy-charge.com/refund-cancellation-policy.php" target="_blank" style="color: #00796a;">Refund &
            Cancellation Policy</a>
    </footer>
</div>